// The small external store behind every bottom-right upload tray (Files, forms,
// redactions). It lives outside React so an upload keeps running, and the tray
// keeps showing it, while the officer moves around the app. Components read it
// with useSyncExternalStore(store.subscribe, store.get).
export interface TrayStoreItem {
  id: string;
  status: string;
}

export function createTrayStore<T extends TrayStoreItem>(
  // Statuses that mean "still working": clearFinished keeps these.
  activeStatuses: string[],
) {
  let items: T[] = [];
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach((l) => l());
  const set = (next: T[]) => {
    items = next;
    emit();
  };

  return {
    get: () => items,
    subscribe: (l: () => void) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    add: (item: T) => set([...items, item]),
    patch: (id: string, p: Partial<T>) => set(items.map((i) => (i.id === id ? { ...i, ...p } : i))),
    remove: (id: string) => set(items.filter((i) => i.id !== id)),
    // Dismiss: drop everything that has finished (done, failed, ...).
    clearFinished: () => set(items.filter((i) => activeStatuses.includes(i.status))),
    reset: () => set([]),
  };
}
